/**
 * Common actions
 */
import { dispatch } from 'store';

import { Locale } from '../../config';
import {
  APP_DATA_INIT_CALL, //
  BROWSER_NAVIGATION_BUTTON_PRESSED,
  CACHE_DATA,
  LOCALE_SET,
} from '../action-types/common.action-types';

// Cache data to store
export const cacheData = (cacheKey, data) => dispatch({ type: CACHE_DATA, cacheKey, data });

// Store data about navigation button pressed
export const setBrowserNavigationButtonPressed = (isPressed) => dispatch({ type: BROWSER_NAVIGATION_BUTTON_PRESSED, isPressed });

// The event can be used as an initial trigger for fetching server data from the client side
export const callAppDataInit = () =>
  dispatch({
    type: APP_DATA_INIT_CALL,
  });

export const storeLocale = (locale: Locale) => dispatch({ type: LOCALE_SET, locale });
